import Icon, { type IconString } from '2-core-elements/Icon/Icon';

export type BadgeProps = {
    label: string;
    skin?: 'type-1' | 'type-2' | 'type-3' | 'success' | 'error' | 'warning' | 'info';
    variant?: 'primary' | 'secondary' | 'tertiary';
    size?: 'sm' | 'md' | 'lg';
    prefixIcon?: IconString;
    onClick?: React.MouseEventHandler<HTMLDivElement>;
    ariaLabel?: string;
    className?: string;
};

const Chip = ({ skin = 'type-1', variant = 'primary', label, size = 'md', prefixIcon, onClick, ariaLabel, className }: BadgeProps): JSX.Element => {
    // Keyboard handler for accessibility
    const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>): void => {
        if (!onClick) {
            return;
        }
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            // Simulate click
            (e.target as HTMLDivElement).click();
        }
    };
    const actAsButton = onClick ? {
        role: 'button',
        tabIndex: 0,
        onClick,
        onKeyDown: handleKeyDown,
        'aria-label': ariaLabel,
    } : undefined;

    return (
        <div
            className={`badge badge-${skin} badge-${variant} badge-${size}${actAsButton ? ' badge-as-button' : ''} ${className}`}
            {...(actAsButton ? { ...actAsButton } : {})} // eslint-disable-line react/jsx-props-no-spreading
        >
            {prefixIcon && <Icon icon={prefixIcon} />}
            {label}
        </div>
    );
};

export default Chip;
